/*--------------------------------------------------------------
# JS Bootstrap
--------------------------------------------------------------*/

import * as bootstrap from 'bootstrap';

document.addEventListener("DOMContentLoaded", function () {
    if (document.body.classList.contains("body-home")) {
        const carouselHome = document.querySelector('#carouselHome');
        if (carouselHome) {
            // Initialize carousel with Bootstrap native cycling
            const carousel = new bootstrap.Carousel(carouselHome, {
                interval: 5000, // Default interval, overridden by data-bs-interval
                ride: 'carousel'
            });

            // Function to handle video playback
            function handleVideoPlayback(slideElement) {
                // Pause all videos first
                const allVideos = carouselHome.querySelectorAll('video');
                allVideos.forEach(video => {
                    video.pause();
                    video.currentTime = 0;
                });

                // Start video in current slide if it exists
                const currentVideo = slideElement.querySelector('video');
                if (currentVideo) {
                    setTimeout(() => {
                        currentVideo.currentTime = 0;
                        currentVideo.play().catch(error => {
                            console.log('Video autoplay prevented:', error);
                            currentVideo.muted = true;
                            currentVideo.play().catch(e => {
                                console.log('Video autoplay still prevented:', e);
                            });
                        });
                    }, 100);
                }
            }

            // Listen for carousel slide events
            carouselHome.addEventListener('slid.bs.carousel', function(event) {
                handleVideoPlayback(event.relatedTarget);
            });

            // Handle video for first slide
            const firstSlide = carouselHome.querySelector('.carousel-item.active');
            if (firstSlide) {
                handleVideoPlayback(firstSlide);
            }

            // Pause on hover (Bootstrap native)
            carouselHome.addEventListener('mouseenter', function() {
                carousel.pause();
            });

            // Resume on mouse leave (Bootstrap native)
            carouselHome.addEventListener('mouseleave', function() {
                carousel.cycle();
            });
        }
    }
});
